import "./IndividualBlog.css";
import React, { useContext, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import blogsContext from "../../context/blogs/blogscontext";
import progressContext from "../../context/loading/progresscontext";
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import CtaBand from "../home/ctaband/CtaBand";

function IndividualBlog() {
  const { setProgress } = useContext(progressContext);
  const { blogs } = useContext(blogsContext);
  const { url } = useParams();

  useEffect(() => {
    if (setProgress) {
      setProgress(70);
      setTimeout(() => {
        setProgress(100);
      }, 100);
    }
  }, [setProgress]);

  const currentBlog = blogs ? blogs.find((item) => item.url === url) : null;

  useEffect(() => {
    if (currentBlog) {
      document.title = currentBlog.metaT || currentBlog.title;
      document.querySelector('meta[name="description"]')?.setAttribute('content', currentBlog.metaD || '');
      document.querySelector('meta[name="keywords"]')?.setAttribute('content', currentBlog.metaK || '');
    }
  }, [currentBlog]);

  if (!currentBlog) {
    return (
      <main className="single-blog-page">
        <Breadcrumb
          pageName="Article"
          bgImage="/img/uplaods/rad.jpg"
          path={[
            { label: 'Home', href: '/' },
            { label: 'Blogs', href: '/blogs' },
            { label: 'Not Found' }
          ]}
        />
        <section className="band">
          <div className="wrap text-center">
            <h2>Article not found</h2>
            <p style={{ marginTop: '16px' }}><Link to="/blogs" className="btn btn-solid">View all articles</Link></p>
          </div>
        </section>
      </main>
    );
  }

  return (
    <main className="single-blog-page">
      <Breadcrumb
        pageName={currentBlog.title}
        bgImage="/img/uplaods/rad.jpg"
        path={[
          { label: 'Home', href: '/' },
          { label: 'Blogs', href: '/blogs' },
          { label: currentBlog.title }
        ]}
      />

      <section className="band">
        <div className="wrap">
          <div className="blog-article-wrap">
            <Link to="/blogs" className="blog-back-btn">
              &larr; Back to all articles
            </Link>

            {currentBlog.imgSrc && (
              <img
                src={`/img/uplaods/${currentBlog.imgSrc}`}
                alt={currentBlog.title}
                className="blog-hero-image"
                loading="lazy"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            )}

            <div className="blog-article-header">
              <span className="blog-meta-badge">
                {currentBlog.publishedAt ? new Date(currentBlog.publishedAt).toLocaleDateString("en-GB", { day: 'numeric', month: 'long', year: 'numeric' }) : 'Medical Article'}
              </span>
              <h1>{currentBlog.title}</h1>
            </div>

            <div className="blog-article-body">
              {currentBlog.content && (
                <div dangerouslySetInnerHTML={{ __html: currentBlog.content }}></div>
              )}
              {currentBlog.content2 && <p>{currentBlog.content2}</p>}

              {currentBlog.headtext1 && <h3>{currentBlog.headtext1}</h3>}
              {currentBlog.para1 && <p>{currentBlog.para1}</p>}
              {currentBlog.param && <ul>{currentBlog.param}</ul>}
              {currentBlog.title2 && <p>{currentBlog.title2}</p>}
              {currentBlog.title3 && <p>{currentBlog.title3}</p>}

              {currentBlog.headtext2 && <h3>{currentBlog.headtext2}</h3>}
              {currentBlog.title4 && <p>{currentBlog.title4}</p>}
              {currentBlog.title5 && <p>{currentBlog.title5}</p>}
              {currentBlog.param2 && <div dangerouslySetInnerHTML={{ __html: currentBlog.param2 }}></div>}

              {currentBlog.headtext3 && <h3>{currentBlog.headtext3}</h3>}
              {currentBlog.title6 && <div dangerouslySetInnerHTML={{ __html: currentBlog.title6 }}></div>}
              {currentBlog.title7 && <p>{currentBlog.title7}</p>}

              {currentBlog.headtext4 && <h3>{currentBlog.headtext4}</h3>}
              {currentBlog.title8 && <p>{currentBlog.title8}</p>}
              {currentBlog.title9 && <p>{currentBlog.title9}</p>}

              {currentBlog.headtext5 && <h3>{currentBlog.headtext5}</h3>}
              {currentBlog.title10 && <div dangerouslySetInnerHTML={{ __html: currentBlog.title10 }}></div>}
              {currentBlog.title11 && <p>{currentBlog.title11}</p>}

              {currentBlog.headtext6 && <h3>{currentBlog.headtext6}</h3>}
              {currentBlog.title12 && <p>{currentBlog.title12}</p>}
              {currentBlog.title13 && <div dangerouslySetInnerHTML={{ __html: currentBlog.title13 }}></div>}

              {currentBlog.headtext7 && <h3>{currentBlog.headtext7}</h3>}
              {currentBlog.title14 && <p>{currentBlog.title14}</p>}
              {currentBlog.title15 && <p>{currentBlog.title15}</p>}
            </div>
          </div>
        </div>
      </section>

      <CtaBand />
    </main>
  );
}

export default IndividualBlog;

